export enum GeniallyIncompatibleErrorCause {
  DRAFT = 'Draft',
  HAS_PASSWORD = 'HasPassword',
  RESTRICTED = 'Restricted',
  FORBIDDEN = 'Forbidden',
}

export class GeniallyIncompatibleError extends Error {
  private constructor(public readonly cause: GeniallyIncompatibleErrorCause) {
    super(`Genially is incompatible: ${cause}`);
  }

  static causeIsDraft(): GeniallyIncompatibleError {
    return new GeniallyIncompatibleError(GeniallyIncompatibleErrorCause.DRAFT);
  }

  static causeHasPassword(): GeniallyIncompatibleError {
    return new GeniallyIncompatibleError(GeniallyIncompatibleErrorCause.HAS_PASSWORD);
  }

  static causeIsRestricted(): GeniallyIncompatibleError {
    return new GeniallyIncompatibleError(GeniallyIncompatibleErrorCause.RESTRICTED);
  }

  static causeIsForbidden(): GeniallyIncompatibleError {
    return new GeniallyIncompatibleError(GeniallyIncompatibleErrorCause.FORBIDDEN);
  }
}
